import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "search-view-results" }
const _hoisted_2 = { class: "search-view-results__links" }
const _hoisted_3 = { class: "search-view-results__facets" }
const _hoisted_4 = { class: "search-view-results__facet-suggestions" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "search-view-results__pages"
}
const _hoisted_7 = { class: "search-view-results__page-caption" }
const _hoisted_8 = { class: "search-view-results__page-links" }
const _hoisted_9 = { class: "search-view-results__page-suggestion-text" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "search-view-results__page-suggestion-spacer" }, "|", -1)
const _hoisted_11 = {
  key: 0,
  class: "search-view-results__products-wrapper"
}
const _hoisted_12 = { class: "search-view-results__products" }
const _hoisted_13 = {
  key: 1,
  class: "search-view-results__no-result"
}

import { computed, nextTick } from 'vue';

import useContext from '@/composables/useContext';
import useWebsiteTexts from '@/composables/useWebsiteTexts';

import ProductCard from '../ProductCard.vue';
import { getSearchContext } from '@/composables/useSearch';



export default /*#__PURE__*/_defineComponent({
  __name: 'SearchViewDesktopResults',
  setup(__props) {

const { websiteText } = useWebsiteTexts();
const { mitt } = useContext();
const {
  hasAnySearchResults,
  facetSuggestions,
  pageHits,
  pages,
  productHits,
  productHitsLabel,
  performFullSearch,
  products,
} = getSearchContext();


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(facetSuggestions), (facet) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: facet }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(facet.suggestedValues, (facetValue) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: facetValue.value,
                  class: "search-view-results__facet-value-suggestion",
                  onClick: ($event: any) => (
                  _unref(mitt).emit('apply-facet-suggestion', {
                    facetId: facet.field,
                    facetValueId: facetValue.value,
                  })
                )
                }, _toDisplayString(facetValue.label), 9, _hoisted_5))
              }), 128))
            ], 64))
          }), 128))
        ]),
        (_unref(productHits))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "search-view-results__all-product-hits",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(performFullSearch)()))
            }, _toDisplayString(_unref(productHitsLabel)), 1))
          : _createCommentVNode("", true)
      ]),
      (_unref(pageHits))
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(websiteText)('search__page_results_title').value), 1),
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pages), (page, idx) => {
                return (_openBlock(), _createBlock(_component_router_link, {
                  key: `${page.url}${idx}`,
                  to: page.url,
                  class: "search-view-results__page-suggestion",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(mitt).emit('clear-search-input')))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(page.pageName), 1),
                    _hoisted_10
                  ]),
                  _: 2
                }, 1032, ["to"]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_unref(products).length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(products), (product, idx) => {
              return (_openBlock(), _createBlock(ProductCard, {
                class: "search-view-results__product",
                key: `${product.articleNumber}${idx}`,
                product: product,
                "hide-related-articles": true,
                onClick: _cache[2] || (_cache[2] = ($event: any) => {
            _unref(mitt).emit('search-result-clicked');
            _unref(mitt).emit('clear-search-input');
          })
              }, null, 8, ["product"]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (!_unref(hasAnySearchResults))
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_unref(websiteText)('search__no_hits').value), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})